import React, { useContext } from "react";
import Header from "components/Header";
import style from "./index.module.scss";
import { Breadcrumb, Spin } from "antd";
import CourseHeader from "./components/CourseHeader";
import { Link } from "react-router-dom";
import { CourseContext } from "../../Store";

interface CourseLayoutProps {
    children: React.ReactNode;
}

export default function ChaptersLayout({ children }: CourseLayoutProps) {
    const { basename } = useContext(CourseContext);

    return (
        <div className="PopupContainer">
            <Header />

            <div className={style.container}>
                <Breadcrumb separator=">">
                    <Breadcrumb.Item>
                        <Link to="/">首页</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={`${basename}/resource`}>课程内容</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>课程章节</Breadcrumb.Item>
                </Breadcrumb>

                <div className={style.body}>
                    <React.Suspense
                        fallback={
                            <Spin>
                                <div style={{ height: 400 }} />
                            </Spin>
                        }>
                        <CourseHeader />
                        <div className={style.main}>{children}</div>
                    </React.Suspense>
                </div>
            </div>
        </div>
    );
}
